/**
 * Code Store Actions
 */

import type { StoreApi } from 'zustand'

import type { CodeActions, CodeStore } from './types'

type SetState = StoreApi<CodeStore>['setState']

export const createCodeActions = (set: SetState): CodeActions => ({
  setSelectedTechnology: (technology: string) => {
    set((state) => ({
      ...state,
      selectedTechnology: technology,
    }))
  },
})
